"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAddress = void 0;
const c32check_1 = require("c32check");
const validateAddress = (input) => {
    try {
        const [version, data] = (0, c32check_1.c32addressDecode)(input);
        return { isValid: true, data: { version, data } };
    }
    catch (e) {
        return { isValid: false, error: e };
    }
};
exports.validateAddress = validateAddress;
//# sourceMappingURL=addresses.js.map